import { createVNode as a, mergeProps as n } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NoResultTwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return a(d, n(e, {
    icon: s
  }), null);
};
t.displayName = "NoResultTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
